var map = {
	"./Enquiry/Enquiry.module": [
		"../../../../../src/app/Enquiry/Enquiry.module.ts",
		"common",
		"Enquiry.module"
	],
	"./Exprzpay/Exprzpay.module": [
		"../../../../../src/app/Exprzpay/Exprzpay.module.ts",
		"common",
		"Exprzpay.module"
	],
	"./Exprzpayresp/Exprzpayresp.module": [
		"../../../../../src/app/Exprzpayresp/Exprzpayresp.module.ts",
		"common",
		"Exprzpayresp.module"
	],
	"./Payments/Payments.module": [
		"../../../../../src/app/Payments/Payments.module.ts",
		"common",
		"Payments.module"
	],
	"./PgReg/PgReg.module": [
		"../../../../../src/app/PgReg/PgReg.module.ts",
		"common",
		"PgReg.module"
	],
	"./Regformsims/Regformsims.module": [
		"../../../../../src/app/Regformsims/Regformsims.module.ts",
		"common",
		"Regformsims.module"
	],
	"./Stuenquiry/Stuenquiry.module": [
		"../../../../../src/app/Stuenquiry/Stuenquiry.module.ts",
		"common",
		"Stuenquiry.module"
	],
	"./docpage/Docpage.module": [
		"../../../../../src/app/docpage/Docpage.module.ts",
		"common",
		"Docpage.module"
	],
	"./feedbacklogin/feedbacklogin.module": [
		"../../../../../src/app/feedbacklogin/feedbacklogin.module.ts",
		"common",
		"feedbacklogin.module"
	],
	"./memberform/memberform.module": [
		"../../../../../src/app/memberform/memberform.module.ts",
		"common",
		"memberform.module.0"
	],
	"./memberregisterform/memberform.module": [
		"../../../../../src/app/memberregisterform/memberform.module.ts",
		"common",
		"memberform.module"
	],
	"./stflogin/stflogin.module": [
		"../../../../../src/app/stflogin/stflogin.module.ts",
		"common",
		"stflogin.module"
	],
	"./stfreg/stfreg.module": [
		"../../../../../src/app/stfreg/stfreg.module.ts",
		"common",
		"stfreg.module"
	],
	"./stuenquirypg/Stuenquirypg.module": [
		"../../../../../src/app/stuenquirypg/Stuenquirypg.module.ts",
		"common",
		"Stuenquirypg.module"
	],
	"./stulogin/stulogin.module": [
		"../../../../../src/app/stulogin/stulogin.module.ts",
		"common",
		"stulogin.module"
	],
	"./stureg/stureg.module": [
		"../../../../../src/app/stureg/stureg.module.ts",
		"common",
		"stureg.module"
	],
	"./sturegdg/sturegdg.module": [
		"../../../../../src/app/sturegdg/sturegdg.module.ts",
		"common",
		"sturegdg.module"
	],
	"./sturegid/sturegid.module": [
		"../../../../../src/app/sturegid/sturegid.module.ts",
		"common",
		"sturegid.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main